import { apiFileFetch } from '../../helpers/restRequest'

const fetchContractPdfUrl = async (id) => {
  const blob = await apiFileFetch(`/employee_contracts/${id}/document`)
  if (!(blob instanceof Blob) || blob.type !== 'application/pdf') return null

  return URL.createObjectURL(blob)
}

export const openContractPdf = async (id) => {
  const tab = window.open('', '_blank')

  try {
    const url = await fetchContractPdfUrl(id)
    if (!url) {
      if (tab) tab.close()
      return false
    }

    if (tab) {
      tab.location.href = url
    } else {
      window.open(url, '_blank')
    }

    return true
  } catch (error) {
    if (tab) tab.close()
    throw error
  }
}
